import { render, staticRenderFns } from "./OrgDetailsCustomer.vue?vue&type=template&id=6534fd37&"
import script from "./OrgDetailsCustomer.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports